import React from "react";
import { useNavigate } from "react-router-dom";
import {
     MainLeftTitle,
     CreateButton,
} from "../../../_uiComponents/WrapperComponents";
import { SearchBarWr } from "../../../_uiComponents/common/form/UiInputComponents";
import NotificationTableFilterForm from "./forms/NotificationTableFilterForm";
import { MessageServiceForm } from "./ManageNotification";
import { UiAccordian } from "../../../_uiComponents/common/form/UiToggleArea";


function ManageNotificationWrapper() {
    const navigate = useNavigate();
    const handleData = () => {
        let path = `/ui/create-notification-table`;
        navigate(path);
    }

     return (
          <>
          <div className="sbt-data-grid__wr">
               <MainLeftTitle title="Manage Notifications">
                    <CreateButton name="Create Notification" onClick={handleData} />
               </MainLeftTitle>
                    <UiAccordian>
                         <SearchBarWr>
                              <NotificationTableFilterForm/>
                         </SearchBarWr>
                    </UiAccordian>
               <MessageServiceForm />
          </div>
          </>
     );
}

export default ManageNotificationWrapper;